import html2canvas from 'html2canvas';

const exportAgendaToImage = async (node, fileName, toast) => {
  if (!node) {
    toast?.error?.('No hay contenido para exportar');
    return;
  }
  try {
    const fullHeight = Math.max(node.scrollHeight, node.offsetHeight);
    const fullWidth = Math.max(node.scrollWidth, node.offsetWidth);
    const canvas = await html2canvas(node, {
      scale: 2,
      backgroundColor: '#ffffff',
      useCORS: true,
      height: fullHeight,
      width: fullWidth,
      windowHeight: fullHeight,
    });
    const dataUrl = canvas.toDataURL('image/png');
    const a = document.createElement('a');
    a.href = dataUrl;
    a.download = fileName || 'agenda.png';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    toast?.success?.('Imagen descargada');
  } catch (err) {
    console.error('exportAgendaToImage error:', err);
    toast?.error?.('Error al generar la imagen');
  }
};

export default exportAgendaToImage;
